/**
 * Catálogo de tipos de documento de RH para el FileManager.
 *
 * El `id` de cada entrada es el `kidtipodocumento` REAL del catálogo central
 * del FileManager (`public.cattipodocumento`) provisionado para el sistema de
 * RH (`fkidsistema = 40` en `public.relsistematipodocumento`). Es el valor que
 * se envía como `IdFileType` al subir un archivo. La etiqueta `nombre` es la
 * versión amigable que se muestra en el modal.
 *
 * Fuente del mapeo: `docs/data-1779924988724.csv` (JOIN de
 * `relsistematipodocumento` + `cattipodocumento` filtrado por `fkidsistema = 40`).
 * Si el DBA del FileManager agrega/cambia tipos para el sistema 40, actualizar
 * aquí (o migrar a `GET /FileManager/GetFileCatalog` filtrando por sistema).
 */
export interface TipoDocumentoRH {
  /** kidtipodocumento real del FileManager — se envía como IdFileType al subir. */
  id: number;
  /** Etiqueta visible en el modal. */
  nombre: string;
}

export const TIPOS_DOCUMENTO_RH: ReadonlyArray<TipoDocumentoRH> = [
  { id: 23, nombre: 'Acta de Nacimiento' },
  { id: 24, nombre: 'CURP' },
  { id: 25, nombre: 'INE' },
  { id: 26, nombre: 'Pasaporte' },
  { id: 36, nombre: 'RFC' },
  { id: 27, nombre: 'Número de Afiliación al IMSS' },
  { id: 28, nombre: 'Estado de cuenta bancaria' },
  { id: 29, nombre: 'Comprobante de estudios' },
  { id: 30, nombre: 'Comprobante de domicilio' },
  { id: 31, nombre: 'Solicitud de empleo o currículum' },
  { id: 32, nombre: 'Fotografías tamaño infantil' },
  { id: 33, nombre: 'Cartas de recomendación' },
  { id: 34, nombre: 'Recibos de pago anteriores' },
  { id: 35, nombre: 'Cuestionario de Datos (Excel)' },
] as const;
